import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// CLASSIC VIEW DISABLED - Set to true to re-enable classic homepage option
const CLASSIC_VIEW_DISABLED = true;

export function HomeRedirect() {
  const navigate = useNavigate();
  const { homepageTheme, setHomepageTheme, THEMES } = useTheme();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const determineHomepage = async () => {
      // If Classic view is disabled, always go to Premium
      if (CLASSIC_VIEW_DISABLED) {
        navigate('/home-premium', { replace: true });
        setChecked(true);
        return;
      }

      // --- CLASSIC VIEW CODE (Currently disabled) ---
      // Check if user has a saved preference in localStorage
      const savedPreference = localStorage.getItem('mfs_homepage_theme');
      
      if (savedPreference) {
        // User has explicitly set a preference, use it
        if (savedPreference === THEMES.PREMIUM) {
          navigate('/home-premium', { replace: true });
        } else {
          navigate('/home-classic', { replace: true });
        }
      } else {
        // No user preference, check admin settings
        try {
          const response = await fetch(`${API_URL}/api/site-settings`);
          if (response.ok) {
            const settings = await response.json();
            const defaultTheme = settings.default_homepage === 'classic' ? THEMES.CLASSIC : THEMES.PREMIUM;
            setHomepageTheme(defaultTheme);
            navigate(settings.default_homepage === 'classic' ? '/home-classic' : '/home-premium', { replace: true });
          } else {
            // Fallback to premium
            navigate('/home-premium', { replace: true });
          }
        } catch (error) {
          // Network error, fallback to premium
          console.error('Failed to fetch site settings:', error);
          navigate('/home-premium', { replace: true });
        }
      }
      setChecked(true);
    };

    determineHomepage();
  }, [navigate, THEMES, setHomepageTheme]);

  // Show loading while determining redirect
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return null;
}
